var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-pinterest") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.632,15.632 C6.4,15.864 7.176,16 8,16 C12.418278,16 16,12.418278 16,8 C16,5.87826808 15.1571453,3.84343678 13.6568542,2.34314575 C12.1565632,0.842854723 10.1217319,0 8,0 C3.581722,0 0,3.581722 0,8 C0,11.4 2.136,14.32 5.152,15.472 C5.08,14.848 5.008,13.816 5.152,13.104 L6.072,9.152 C6.072,9.152 5.84,8.688 5.84,7.952 C5.84,6.848 6.528,6.024 7.312,6.024 C8,6.024 8.32,6.528 8.32,7.176 C8.32,7.864 7.864,8.848 7.632,9.792 C7.496,10.576 8.048,11.264 8.848,11.264 C10.272,11.264 11.376,9.744 11.376,7.6 C11.376,5.68 10,4.368 8.024,4.368 C5.768,4.368 4.44,6.048 4.44,7.816 C4.44,8.504 4.664,9.2 5.032,9.656 C5.104,9.704 5.104,9.768 5.08,9.888 L4.848,10.76 C4.848,10.896 4.76,10.944 4.624,10.848 C3.6,10.4 3.008,8.944 3.008,7.768 C3.008,5.24 4.8,2.944 8.256,2.944 C11.008,2.944 13.152,4.92 13.152,7.544 C13.152,10.296 11.448,12.504 9.008,12.504 C8.232,12.504 7.472,12.088 7.2,11.6 L6.664,13.496 C6.48,14.184 5.976,15.104 5.632,15.656 L5.632,15.632 Z",
    id: "icon-pinterest",
    fill: "#E60023",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinterest);
export default __webpack_public_path__ + "static/media/icon-pinterest.078b5ad079af02852d18cde55bebd2db.svg";
export { ForwardRef as ReactComponent };